<app-top-section></app-top-section>

<section>
  <!-- Boutons principaux - grille max 5 colonnes -->
  <div class="button-grid">
    @if (!isGameInOvertime) {
      <a routerLink="/game-play/kickoff-selection" routerLinkActive="active"
        class="primary-action-btn" data-testid="kickoff">
        {{ 'components.menuActions.kickoff' | transloco }}
      </a>
    }
    <a routerLink="/game-play/run" routerLinkActive="active" class="primary-action-btn" data-testid="run">
      {{ 'components.menuActions.run' | transloco }}
    </a>
    <a routerLink="/game-play/complete-pass" routerLinkActive="active" class="primary-action-btn"
      data-testid="completePass">
      {{ 'components.menuActions.completePass' | transloco }}
    </a>
    <a routerLink="/game-play/incomplete-pass" routerLinkActive="active" class="primary-action-btn"
      data-testid="incompletePass">
      {{ 'components.menuActions.incompletePass' | transloco }}
    </a>
    <a routerLink="/game-play/pat-2pts" routerLinkActive="active" class="primary-action-btn" data-testid="pat2pts">
      {{ 'components.menuActions.afterTD' | transloco }}
    </a>
  </div>

  <!-- Boutons secondaires - grille séparée -->
  <div class="button-grid-secondary">
    <a routerLink="/game-play/interception" routerLinkActive="active" class="secondary-action-btn"
      data-testid="interception">
      {{ 'components.menuActions.interception' | transloco }}
    </a>
    <a routerLink="/game-play/qb-sack" routerLinkActive="active" class="secondary-action-btn" data-testid="qBSack">
      {{ 'components.menuActions.qBSack' | transloco }}
    </a>
    <a routerLink="/game-play/punt" routerLinkActive="active" class="secondary-action-btn" data-testid="punt">
      {{ 'components.menuActions.punt' | transloco }}
    </a>
    <a routerLink="/game-play/fg-attempt" routerLinkActive="active" class="secondary-action-btn"
      data-testid="fgAttempt">
      {{ 'components.menuActions.fgAttempt' | transloco }}
    </a>
    <a routerLink="/game-play/team-lost" routerLinkActive="active" class="secondary-action-btn" data-testid="teamLost">
      {{ 'components.menuActions.teamLost' | transloco }}
    </a>
    <button class="secondary-result-btn" data-testid="preSnapPenalty"
      (click)="openDialogPenalty({finishTagOnClose: true})">
      {{ 'components.menuActions.preSnapPenalty' | transloco }}
    </button>
  </div>
</section>